import dayjs from 'dayjs';

import { useMemo } from 'react';

import FormHeader from 'components/global/FormHeader';
import { HeaderContainerFormHeader } from 'components/global/styled/FormHeader.styled';
import DynamicList from 'components/list/DynamicList';
import { FilterAction, FilterType, ListComponents } from 'components/list/DynamicListFilterUtils';

import { ENUMS, REPORT } from 'services/consts';

import { DYNAMICLISTS } from 'utils/constants';
import PATHS, { mergePaths } from 'utils/paths';

import { faArrowLeft } from '@fortawesome/pro-solid-svg-icons';

const PackingStatusReports = () => {
	const columns = useMemo(() => [
		{
			Header: 'date',
			accessor: 'Date',
			filterType: FilterType.date,
			renderCell: ListComponents.DATE_TIME_WITH_SECONDS,
			filterRemovable: false,
			showOnMobile: true
		},
		{
			Header: 'orderID',
			accessor: 'OrderID',
			filterType: FilterType.string,
			showOnMobile: true,
			showCopyButton: true
		},

		{ Header: 'description', accessor: 'Description', filterType: FilterType.string, width: 200 },
		{
			Header: 'packingStatus',
			accessor: 'PackingStatus',
			filterType: FilterType.enumMulti,
			enumName: ENUMS.PACKING_STATUS,
			showOnMobile: true
		},
		{
			Header: 'userName',
			accessor: 'UserName',
			filterType: FilterType.string
		}
	]);

	const defaultFilters = useMemo(() => {
		return [
			{
				column: columns[0],
				action: FilterAction.between,
				value: {
					start: dayjs().subtract(29, 'day').startOf('day').toISOString(),
					end: dayjs().endOf('day').toISOString()
				}
			}
		];
	}, []);

	return (
		<div>
			<HeaderContainerFormHeader>
				<FormHeader
					lightTitle="reports"
					boldTitle="packingStatusHistory"
					icon={faArrowLeft}
					backUrl={mergePaths(PATHS.REPORTS, PATHS.OTO_PACK_REPORTS)}
				/>
			</HeaderContainerFormHeader>
			<DynamicList
				id={DYNAMICLISTS.PACKING_STATUS_REPORTS}
				columns={columns}
				defaultFilters={defaultFilters}
				fetchUrl={REPORT.OTO_PACK.GET_PACKING_STATUS_REPORTS}
				exportName="packingStatusReports"
			/>
		</div>
	);
};

export default PackingStatusReports;
